import { X, Upload } from "lucide-react";
import { Card } from "@/components/common/Ornament";
import { metricRows } from "./Tables";

export default function ScenarioCompare({ saved, onRemove, onLoad }) {
  return (
    <Card eyebrow="This Session Only" title="Scenario Comparison" testId="scenario-compare">
      {saved.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="scenario-compare-empty">Save up to 3 scenarios (e.g., Conservative / Base / Upside) to compare them side by side. Saved scenarios are kept in this browser tab only.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[480px]">
            <thead>
              <tr className="border-b border-[#0F2E23]">
                <th className="text-left py-2 pr-2 text-[#3E5C4E] font-semibold">Metric</th>
                {saved.map((s, i) => (
                  <th key={s.id} className="text-right py-2 px-2" data-testid={`scenario-col-${i}`}>
                    <div className="flex items-center justify-end gap-1">
                      <span className="font-display text-lg text-[#0F2E23]">{s.name}</span>
                      <button onClick={() => onLoad(s)} title="Load" className="p-1 text-slate-400 hover:text-[#C59B27]" data-testid={`scenario-load-${i}`}><Upload className="h-3.5 w-3.5" /></button>
                      <button onClick={() => onRemove(s.id)} title="Remove" className="p-1 text-slate-400 hover:text-red-600" data-testid={`scenario-remove-${i}`}><X className="h-3.5 w-3.5" /></button>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {metricRows().map(([label, fn]) => (
                <tr key={label} className="border-b border-[#E2DCD2]">
                  <td className="py-2 pr-2 text-slate-700">{label}</td>
                  {saved.map((s) => <td key={s.id} className="py-2 px-2 text-right font-mono-num text-[#0F2E23]">{fn(s.result)}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
